/* SNEAP header: mobile menu drawer, dropdowns, sticky behaviour, predictive search */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});
  function init() {
    var root = document.getElementById('sn-header');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var section = root.closest('.shopify-section') || root.parentElement;
    S.hideCountHandle = root.dataset.hideHandle || '';

    /* ---- Mobile menu ---- */
    var drawer = root.querySelector('#sn-menu');
    var overlay = root.querySelector('[data-sn-menu-overlay]');
    var menuBtn = root.querySelector('[data-sn-open-menu]');
    function openMenu() {
      drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open'); overlay.classList.add('is-open');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      S.lock(drawer, menuBtn);
      setTimeout(function () { var f = drawer.querySelector('a,button'); if (f) f.focus(); }, 60);
    }
    function closeMenu() {
      drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', '');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      S.unlock(drawer);
    }
    if (menuBtn && drawer) {
      menuBtn.addEventListener('click', openMenu);
      overlay.addEventListener('click', closeMenu);
      drawer.querySelector('[data-sn-close]').addEventListener('click', closeMenu);
      window.addEventListener('resize', function () { if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) closeMenu(); });
    }

    /* ---- Desktop dropdowns: one open at a time, close on outside click / Esc ---- */
    var dds = [].slice.call(root.querySelectorAll('.sn-hd__dd'));
    dds.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; }); });
      if (window.matchMedia('(hover: hover)').matches) {
        var t;
        d.addEventListener('mouseenter', function () { clearTimeout(t); d.open = true; });
        d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.open = false; }, 160); });
      }
    });
    document.addEventListener('click', function (e) { dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dds.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });

    /* ---- Sticky ---- */
    var mode = root.dataset.sticky;
    if (mode !== 'none') {
      section.classList.add('sn-sticky');
      var last = window.pageYOffset;
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        section.classList.toggle('is-scrolled', y > 4);
        if (mode === 'scroll-up') {
          var menuOpen = dds.some(function (d) { return d.open; });
          section.classList.toggle('is-hidden', y > last && y > 160 && !menuOpen);
        }
        last = y;
      }, { passive: true });
    }

    /* ---- Search overlay with live results ---- */
    var search = root.querySelector('#sn-search');
    if (search) {
      var input = search.querySelector('[data-sn-search-input]');
      var results = search.querySelector('[data-sn-search-results]');
      var opener = null, timer, ctrl;
      function openSearch(e) {
        opener = e && e.currentTarget;
        search.removeAttribute('inert'); search.setAttribute('aria-hidden', 'false'); search.classList.add('is-open');
        S.lock(search, opener);
        setTimeout(function () { input.focus(); }, 80);
      }
      function closeSearch() {
        search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); search.setAttribute('inert', '');
        S.unlock(search);
      }
      root.querySelectorAll('[data-sn-open-search]').forEach(function (b) { b.addEventListener('click', openSearch); });
      search.querySelector('[data-sn-close]').addEventListener('click', closeSearch);
      document.addEventListener('click', function (e) {
        if (search.classList.contains('is-open') && !search.contains(e.target) && !e.target.closest('[data-sn-open-search]')) closeSearch();
      });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          fetch(S.url('search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
              if (!ps.length) { results.innerHTML = '<p class="sn-hd__rempty">No products found for “' + S.esc(q) + '”.</p>'; return; }
              results.innerHTML = '<ul class="sn-hd__rlist">' + ps.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + S.esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56" loading="lazy">' : '<span class="sn-hd__rph"></span>';
                var price = p.price ? S.money(Math.round(parseFloat(p.price) * 100)) : '';
                return '<li><a class="sn-hd__ritem" href="' + S.esc(p.url) + '">' + img + '<span><b>' + S.esc(p.title) + '</b><small>' + S.esc(price) + '</small></span></a></li>';
              }).join('') + '</ul><a class="sn-hd__rall" href="' + S.url('search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results</a>';
            })
            .catch(function () {});
        }, 220);
      });
    }

    /* ---- Cart icon: open the drawer instead of loading /cart (drawer mode) ---- */
    root.querySelectorAll('[data-sn-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (S.cartMode === 'drawer' && S.cart && typeof S.cart.open === 'function') {
          e.preventDefault();
          S.cart.open(a);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('#sn-header')) init(); });
})();
